var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 2.16699H4.97921C4.54271 2.16699 4.12408 2.34259 3.81543 2.65515C3.50677 2.96771 3.33337 3.39163 3.33337 3.83366V17.167C3.33337 17.609 3.50677 18.0329 3.81543 18.3455C4.12408 18.6581 4.54271 18.8337 4.97921 18.8337H14.8542C15.2907 18.8337 15.7093 18.6581 16.018 18.3455C16.3266 18.0329 16.5 17.609 16.5 17.167V7.16699L11.5625 2.16699Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 2.16699V7.16699H16.5",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/Pages.83b5abbc4b8d233d3c1f05bbc40f6eb0.svg";
export { ForwardRef as ReactComponent };